export default {
  install(Vue) {
    Vue.directive('visible', (el, bind) => {
      el.style.visibility = bind.value ? 'visible' : 'hidden';
    });
  },
};
